import type { FC } from 'react';

import classnames from 'classnames';

import styles from './MedicalInfo.module.less';

interface MedicalInfoProps {
    isNicotine?: boolean;
    isPharmaceutical?: boolean;
}

export const getMedicalProductTeaserMessage = (data: {
    isNicotineProduct?: boolean;
    isPharmaceutical?: boolean;
}) => {
    if (!data.isNicotineProduct && !data.isPharmaceutical) return [];

    return [
        ...(data.isPharmaceutical ? ['Läkemedel'] : []),
        ...(data.isNicotineProduct ? ['Får ej säljas vid misstanke om langning'] : []),
    ];
};

export const ItemMedicalInfo: FC<React.PropsWithChildren<MedicalInfoProps>> = (props) => {
    const message = getMedicalProductTeaserMessage({
        isNicotineProduct: props.isNicotine,
        isPharmaceutical: props.isPharmaceutical,
    })?.join(', ');

    if (!message) return null;

    return <div className={classnames(styles.NicotineInfo, styles.Item)}>{message}</div>;
};

const ProductMedicalInfo: FC<React.PropsWithChildren<MedicalInfoProps>> = (props) => {
    const message = getMedicalProductTeaserMessage({
        isNicotineProduct: props.isNicotine,
        isPharmaceutical: props.isPharmaceutical,
    })?.join(', ');

    if (!message) return null;

    return <div className={styles.NicotineInfo}>{message}.</div>;
};

export default ProductMedicalInfo;
